module.exports = __webpack_public_path__ + "img/OutdoorsmanBook.336432f9.png";